// src/app/services/keyboard-detection.service.ts
import { Injectable, HostListener } from '@angular/core';
import { NativeAppService } from './native-app.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KeyboardDetectionService {
  private initialViewportHeight: number;
  private averageKeyboardHeight = 300; // Average keyboard height in pixels
  public keyBoardOpen: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private nativeAppService: NativeAppService) {
    this.initialViewportHeight = window.innerHeight;
    this.monitorKeyboard();
  }


  monitorKeyboard() {
    window.addEventListener('resize', () => {
      const currentViewportHeight = window.innerHeight;
      const viewportDifference = this.initialViewportHeight - currentViewportHeight;
      console.log('Viewport difference: ', viewportDifference);
      if (viewportDifference > this.averageKeyboardHeight / 2) {
        if (this.nativeAppService.isFromAppFromAndroidApp()) {
          console.log('Keyboard is likely open on an Android device');
          this.keyBoardOpen.next(true);
        } else {
          console.log('Keyboard is likely open');
        }
      } else {
        if (this.nativeAppService.isFromAppFromAndroidApp()) {
          console.log('Keyboard is likely closed on an Android device');
          this.keyBoardOpen.next(false);
        } else {
          console.log('Keyboard is likely closed');
        }
      }
    });
  }
}
